import React from 'react';
import './ResetConfirmationModal.css';

const ResetConfirmationModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="reset-modal-overlay">
      <div className="reset-modal">
        <h2>Varsayılan CSS'e Dön</h2>
        <p>Varsayılan CSS ayarlarına dönmek istediğinizden emin misiniz?</p>
        <div className="reset-modal-buttons">
          <button className="reset-modal-button cancel" onClick={onCancel}>
            İptal
          </button>
          <button className="reset-modal-button confirm" onClick={onConfirm}>
            Evet, Döndür
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResetConfirmationModal; 